enum PensionAgreementStatus {
  UNDER_ESTABLISHMENT = 'UNDER_ESTABLISHMENT',
  ACTIVE = 'ACTIVE',
  UNDER_CHANGE = 'UNDER_CHANGE',
  TERMINATED = 'TERMINATED',
  ALL_CONTRACTS_TERMINATED = 'ALL_CONTRACTS_TERMINATED',
  ALL_CONTRACTS_TERMINATION_IN_PROGRESS = 'ALL_CONTRACTS_TERMINATION_IN_PROGRESS',
  AGREEMENT_TERMINATION_IN_PROGRESS = 'AGREEMENT_TERMINATION_IN_PROGRESS',
  UNDEFINED = 'UNDEFINED',
}

export default PensionAgreementStatus;
